const normalizeClientName = name => {
  if (!name) return '';

  return String(name).replace(/\s+/g, ' ').trim();
};

export default normalizeClientName;
